// extracted by mini-css-extract-plugin
export default {"title":"Raa-z","warning":"Saa-z","sizeOptionsLegendText":"Taa-z"};